import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import {
  RdsIconButtonComponent,
  RdsIconComponent,
} from '@rds/angular-components';

import {
  ChartDataService,
  ChartSearchParams,
  ViewportService,
} from '@bookly/shared';

import { ChartFilterComponent } from '../chart-filter/chart-filter.component';

@Component({
  selector: 'bsh-chart-filter-menu',
  imports: [RdsIconComponent, ChartFilterComponent, RdsIconButtonComponent],
  templateUrl: './chart-filter-menu.component.html',
  styleUrl: './chart-filter-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartFilterMenuComponent {
  readonly #chartDataService = inject(ChartDataService);
  protected readonly isMobileScreen = inject(ViewportService).isMobile;
  protected readonly showHideClass = signal<'show' | 'hide'>('hide');

  public hideMenu() {
    this.showHideClass.set('hide');
  }

  public showMenu() {
    this.showHideClass.set('show');
  }

  protected applyFilters(filters: ChartSearchParams) {
    this.hideMenu();
    this.#chartDataService.loadChartData(filters).subscribe();
  }
}
